module.exports = __webpack_public_path__ + "img/spinner.1af68cbe.gif";